import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Qué es la terapia de TMS?",
    answer:
      "La TMS (estimulación magnética transcraneal) es un tratamiento no invasivo que utiliza campos magnéticos para estimular las neuronas en una región del cerebro asociada con el estado de ánimo. Está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos.",
  },
  {
    question: "¿Cuál es la diferencia entre TMS y SAINT®?",
    answer:
      "SAINT® es un protocolo de TMS acelerada con orientación por fMRI que se administra durante cinco días. La TMS convencional suele durar seis semanas y utiliza un punto de estimulación estándar.",
  },
];

export const esWhatIsTmsTherapy = makeEsArticle({
  slug: "what-is-tms-therapy-for-depression",
  title: "¿Qué es la terapia de TMS para la depresión?",
  description:
    "La TMS (estimulación magnética transcraneal) es un tratamiento no invasivo autorizado por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® es un protocolo de TMS acelerada.",
  h1: "¿Qué es la terapia de TMS para la depresión?",
  breadcrumbLabel: "¿Qué es la terapia de TMS?",
  shortAnswer:
    "La TMS (estimulación magnética transcraneal) es un tratamiento no invasivo que utiliza campos magnéticos para estimular las neuronas en una región del cerebro asociada con el estado de ánimo. Está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. SAINT® es un protocolo de TMS acelerada con orientación por fMRI que se administra durante cinco días.",
  keyTakeaways: [
    "La TMS es un tratamiento no invasivo.",
    "Utiliza campos magnéticos para estimular las neuronas.",
    "Está autorizada por la FDA para el trastorno depresivo mayor.",
    "Está indicada para adultos que no han mejorado con antidepresivos.",
    "SAINT® es un protocolo de TMS acelerada durante cinco días.",
  ],
  sections: [
    {
      heading: "Cómo funciona la TMS",
      paragraphs: [
        "La TMS utiliza una bobina electromagnética colocada cerca de la cabeza para entregar campos magnéticos que estimulan las neuronas en una región del cerebro asociada con el estado de ánimo. El paciente permanece despierto durante el tratamiento.",
      ],
    },
    {
      heading: "TMS convencional frente a SAINT®",
      paragraphs: [
        "La TMS convencional suele durar seis semanas, con sesiones diarias de lunes a viernes, y utiliza un punto de estimulación estándar. SAINT® es un protocolo de TMS acelerada con orientación individualizada por fMRI que se administra durante cinco días.",
      ],
    },
    {
      heading: "Para quién es",
      paragraphs: [
        "La TMS está autorizada por la FDA para el trastorno depresivo mayor en adultos que no han mejorado con antidepresivos. La idoneidad se confirma mediante una evaluación psiquiátrica. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
